import React from "react";
import { Container, Stack, Stripe } from "@mbank-design/design-system/components";
import { Alignment } from "@mbank-design/design-system/enums";

export const LayoutView = (props: { children: React.ReactNode }): JSX.Element => {
    return (
        <>
            <Stripe/>
            <Container alignItems="center" justifyContent="center">
                <Stack alignX={Alignment.CENTER} spacing={32}>
                    {props.children}
                </Stack>
            </Container>
        </>
    );
}
